function server() {
  // return "http://localhost/vaigaiclaas/";
  // return "https://vaigaiclaas.com/test/api/v1/";
  return "https://dev.strackit.com/vaigai/api/v1/web/";
}

export default server;